import { currencyFormat } from "../utils";
export default function PaymentPrompt({ t, handleConfirmPayment, totalAmount }) {
  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={styles.icon}>💳</div>
        <h3 style={styles.title}>{t("ready_to_continue_payment")}</h3>
        <p style={styles.subtitle}>
          {t("please_review_payment") || "Please review your payment details before continuing."}
        </p>

        <div style={styles.amountBox}>
          <span style={styles.amountLabel}>{t("total_amount") || "Total to Pay:"}</span>
          <span style={styles.amountValue}>{currencyFormat(totalAmount)}</span>
        </div>

        <button
          onClick={handleConfirmPayment}
          style={styles.button}
          onMouseOver={(e) => (e.target.style.background = "#d91e22")}
          onMouseOut={(e) => (e.target.style.background = "#f5272b")}
        >
          {t("proceed_to_payment").toUpperCase()}
        </button>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "60vh",
  },
  card: {
    backgroundColor: "#fff",
    padding: "40px 30px",
    maxWidth: "400px",
    width: "90%",
    textAlign: "center",
  },
  icon: {
    fontSize: "48px",
    marginBottom: "10px",
  },
  title: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#333",
    marginBottom: "8px",
  },
  subtitle: {
    fontSize: "14px",
    color: "#666",
    marginBottom: "24px",
  },
  amountBox: {
    backgroundColor: "#f8f8f8",
    borderRadius: "10px",
    padding: "16px 20px",
    marginBottom: "26px",
    boxShadow: "inset 0 1px 3px rgba(0,0,0,0.05)",
  },
  amountLabel: {
    display: "block",
    color: "#777",
    fontSize: "14px",
    marginBottom: "4px",
  },
  amountValue: {
    fontSize: "22px",
    fontWeight: "bold",
    color: "#222",
  },
  button: {
    background: "#f5272b",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    padding: "12px 26px",
    cursor: "pointer",
    fontSize: "15px",
    fontWeight: 500,
    boxShadow: "0 4px 12px rgba(245,39,43,0.3)",
    transition: "all 0.3s ease",
  },
};
